module.exports = __webpack_public_path__ + "img/newdesignlogo.6c5dc646.svg";